export default __webpack_public_path__ + "static/media/infernal_3.9c98315e.png";